module.exports = __webpack_public_path__ + "img/Icon.67e2799d.svg";